import { ref, watch } from 'vue'
import store from '@/store'
import router from '@/router'

export const loadingMenuRouteName = ref(null)

let watchersBound = false
let clearTimer = null

const clearClearTimer = () => {
  if (clearTimer) {
    window.clearTimeout(clearTimer)
    clearTimer = null
  }
}

export const stopMenuNavigationLoading = () => {
  clearClearTimer()
  loadingMenuRouteName.value = null
}

export const startMenuNavigationLoading = (routeName) => {
  clearClearTimer()
  loadingMenuRouteName.value = routeName
  ensureWatchers()
}

const scheduleClearIfIdle = (routeName) => {
  clearClearTimer()
  clearTimer = window.setTimeout(() => {
    if (loadingMenuRouteName.value === routeName && !store.getters.getPending) {
      loadingMenuRouteName.value = null
    }
    clearTimer = null
  }, 300)
}

const ensureWatchers = () => {
  if (watchersBound) {
    return
  }

  watchersBound = true

  watch(
    () => store.getters.getPending,
    (pending, wasPending) => {
      if (!loadingMenuRouteName.value) {
        return
      }

      if (
        wasPending &&
        !pending &&
        router.currentRoute.value.name === loadingMenuRouteName.value
      ) {
        stopMenuNavigationLoading()
      }
    }
  )

  watch(
    () => router.currentRoute.value.name,
    (routeName) => {
      if (!loadingMenuRouteName.value) {
        return
      }

      if (routeName === loadingMenuRouteName.value) {
        scheduleClearIfIdle(routeName)
        return
      }

      // Navigated somewhere else (e.g. redirect) — keep loader on clicked item
      // until pending settles on the destination, then clear.
      if (!store.getters.getPending) {
        scheduleClearIfIdle(loadingMenuRouteName.value)
      }
    }
  )
}
